import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustSignals } from '../components/TrustSignals';
import { DegreeCategoryGrid } from '../components/DegreeCategoryGrid';
import { SEOContentSection } from '../components/SEOContentSection';
import { FAQSection } from '../components/FAQSection';
export function HomePage() {
  return <main className="flex-grow" data-id="element-544">
      <HeroSection data-id="element-545" />
      <TrustSignals data-id="element-546" />
      <DegreeCategoryGrid data-id="element-547" />
      <SEOContentSection data-id="element-548" />
      <FAQSection data-id="element-549" />
    </main>;
}